import { render, staticRenderFns } from "./SocialMediaSelector.vue?vue&type=template&id=47d0da9b"
import script from "./SocialMediaSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialMediaSelector.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports